import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

export default function Blog() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: 'var(--bg-primary)' }}>
      <div className="text-center max-w-lg">
        {/* Decorative element */}
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6"
             style={{ background: 'var(--accent-soft)', color: 'var(--accent)' }}>
          <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
          </svg>
        </div>

        <h1 className="display-md mb-4" style={{ color: 'var(--text-primary)' }}>
          Blog <span className="gradient-text">Coming Soon</span>
        </h1>
        <p className="subheadline mb-8 max-w-sm mx-auto">
          We're crafting insightful articles about technology, development, and innovation. Stay tuned.
        </p>

        <Link to="/" className="btn-primary">
          Back to Home <FaArrowRight size={11} />
        </Link>
      </div>
    </div>
  );
}
